import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Checkbox, Form, Label } from 'semantic-ui-react'
import axios from 'axios';
import './style.css'

export default function Create() {
	
	const navigate  = useNavigate();

	const [hunterId, setHunterId] = useState('');
	const [marka, setMarka] = useState('');
	const [kalibar, setKalibar] = useState('');
	const [serijskibroj, setSerijskiBroj] = useState('');
	const [oruznilist, setOruzniList] = useState('');
	const [mup, setMUP] = useState('');
	const [photo, setPhoto] = useState('');
	
	useEffect(() => {
        setHunterId(localStorage.getItem('hunterId'))
	}, []);
	
	const updateAPIData = () => {
		axios.post(`http://89.46.196.228:3000/api/rifles`,
			{
				"hunterId": hunterId,
				"marka": marka,
				"kalibar": kalibar,
				"serijskibroj": serijskibroj,
				"oruznilist": oruznilist,
				"mup": mup,
				"photo": photo
			}
			).then(() => {
            navigate('/dashboard/SLOBiHClanovi')
        })
    }

    return (
	    <div className="main">
        <div>
            <Form className="create-form">
				<Form.Field>
                    <Label>Hunter Id</Label>
                    <input placeholder='Hunter Id' value={hunterId} onChange={(e) => setHunterId(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Marka</Label>
                    <input placeholder='Marka' value={marka} onChange={(e) => setMarka(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Kalibar</Label>
                    <input placeholder='Kalibar' value={kalibar} onChange={(e) => setKalibar(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Serijski broj</Label>
                    <input placeholder='Serijski broj' value={serijskibroj} onChange={(e) => setSerijskiBroj(e.target.value)}/>
                </Form.Field>
				
			    <Form.Field>
                    <Label>Oruzni list</Label>
                    <input placeholder='Oruzni list' value={oruznilist} onChange={(e) => setOruzniList(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>MUP</Label>
                    <input placeholder='MUP' value={mup} onChange={(e) => setMUP(e.target.value)}/>
                </Form.Field>
				
                <Button onClick={updateAPIData} type='submit'>Submit</Button>
            </Form>
        </div>
		</div>
    )
}